import { useId } from "react";

import { cn } from "utils/cn";

export const cardClassName =
  "overflow-hidden rounded-xl border bg-background shadow-sm";

export const cardHeaderClassName =
  "flex items-center gap-3 border-b bg-gradient-brand-r px-6 py-4";

type CardProps = Omit<React.HTMLAttributes<HTMLElement>, "title"> & {
  title: string;
  badge?: React.ReactNode;
};

const Card = ({ title, badge, className, children, ...props }: CardProps) => {
  const headingId = useId();

  return (
    <section
      aria-labelledby={headingId}
      className={cn(cardClassName, className)}
      {...props}
    >
      <div className={cardHeaderClassName}>
        <h2
          id={headingId}
          className="font text-lg font-medium text-brand-copy-primary"
        >
          {title}
        </h2>
        {badge}
      </div>
      {children}
    </section>
  );
};

export default Card;
